import { Box, Flex, Text, useColorMode, useColorStyle } from '@tonic-one/react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import browserWarning from '../../../assets/image/browser-warning.svg';
const ServiceException = () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const FlexItem = (props: any) => (
    <Box display="inline" verticalAlign="middle" fontSize="14px" {...props} />
  );
  const [traceId, setTraceId] = React.useState<string>();
  useEffect(() => {
    const searchParams = new URL(window.location.toString()).searchParams;
    const id = searchParams.get('traceId') || '';
    setTraceId(id);
  }, []);
  return (
    <>
      <Flex
        alignItems="center"
        bg={colorStyle.background.primary}
        height="100vh"
      >
        <FlexItem flex="auto">{}</FlexItem>
        <FlexItem flex="auto" textAlign="center">
          <img src={browserWarning} />
          <Text
            m={20}
            fontSize={24}
            lineHeight="32px"
            color={colorStyle.color.primary}
          >
            {t('common.unableToAccess.unexpectedError.title')}
          </Text>
          <Text color={colorStyle.color.secondary}>
            {t('common.unableToAccess.unexpectedError.description')}
          </Text>
          {traceId && (
            <Text color={colorStyle.color.secondary}>
              {`${t('common.text.traceId')} = ${traceId}`}
            </Text>
          )}
        </FlexItem>
        <FlexItem flex="auto">{}</FlexItem>
      </Flex>
    </>
  );
};
export default ServiceException;
